import { orderOpenCloseEnum } from '../constants/order'
import { Actions } from '../enums/OrderTicket.enum'

/**
 * Determines the order open or close status based on the order action.
 *
 * @param {typeof Actions} action - The action of the order, either 'BUY' or 'SELL'.
 * @returns {string} - Returns 'OPEN' if the action is 'BUY' or 'BUY_OPEN', otherwise returns 'CLOSE'.
 *
 * The following actions are considered 'OPEN' actions:
 * - Buy Open
 * - Buy
 * - Sell Open
 * - Sell Short
 */
export const getOrderOpenCloseByAction = (action) => {
  const openActions = [
    Actions.BuyOpen,
    Actions.Buy,
    Actions.SellOpen,
    Actions.SellShort,
  ]

  return openActions.includes(action)
    ? orderOpenCloseEnum.OPEN
    : orderOpenCloseEnum.CLOSE
}
